import ModelesSaisiesController from './modeles.saisies.controller';

export default {
    template: require('./modeles.saisies.tpl.html'),
    controller: ModelesSaisiesController
};
